import {Drawer, Grid, IconButton, Stack} from "@mui/joy";
import SideBar, {SideBarContent} from "../components/Layout/SideBar";
import {Outlet} from "react-router-dom";
import React, {useState} from "react";
import {MenuIcon} from "lucide-react";
import {useUITheme} from "../hooks/useUITheme";
import BottomNavbar from "../components/Layout/BottomNavbar";
import NavBar from "../components/Layout/NavBar";
import LanguageTestSetupDialog from "../components/LanguageTestSetupDialog";
import EmailVerificationBanner from "../components/EmailVerificationBanner";

/** The signed-in layout. Renders the matched route, or `children` when wrapping a page directly (the 404 page). */
const Main = (props: { children?: React.ReactNode }) => {
    return <Stack height={"100%"}>

        <Grid container style={{height: "100%"}}>

            <Grid xs={12} sx={{overflow: "hidden", height: "100%",}}>
                <Stack direction={{md: "row"}} sx={{height: "100%"}}>
                    <NavBar/>

                    <SideBar/>

                    {/* Fills the space between the navbars, so short content (like a loader) can't pull the
                        bottom tab bar up from the bottom of the screen. */}
                    <Stack paddingTop={2} flex={1} minHeight={0} sx={{overflowY: "auto", width: "100%"}}>
                        <EmailVerificationBanner/>
                        {props.children ?? <Outlet/>}
                    </Stack>

                    <BottomNavbar/>
                </Stack>
            </Grid>

        </Grid>

    </Stack>
}

export default Main